import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const featureImages = [
  'https://readdy.ai/api/search-image?query=Clean%20modern%20laptop%20on%20warm%20wooden%20desk%20displaying%20spreadsheet%20interface%20with%20product%20listings%2C%20coffee%20cup%20beside%2C%20soft%20natural%20morning%20light%20through%20window%2C%20cozy%20productive%20workspace%20atmosphere%2C%20minimalist%20lifestyle%20photography%2C%20warm%20beige%20and%20gray%20tones%2C%20calm%20focused%20aesthetic&width=600&height=400&seq=feature-v2-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Professional%20comparison%20scene%20with%20two%20tablets%20side%20by%20side%20on%20light%20stone%20surface%2C%20showing%20different%20shopping%20interfaces%2C%20soft%20diffused%20office%20lighting%2C%20clean%20modern%20business%20aesthetic%2C%20warm%20neutral%20palette%2C%20editorial%20tech%20lifestyle%20photography%20with%20subtle%20reflections&width=600&height=400&seq=feature-v2-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Shipping%20package%20and%20fashion%20items%20on%20warm%20light%20background%20with%20world%20map%20subtle%20backdrop%2C%20delivery%20concept%2C%20soft%20natural%20daylight%2C%20clean%20modern%20ecommerce%20photography%2C%20warm%20optimistic%20tones%2C%20organized%20composition%20with%20open%20cardboard%20box%20and%20sneakers&width=600&height=400&seq=feature-v2-03&orientation=landscape',
];

export default function FeatureGrid() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-table-line',
      image: featureImages[0],
      title: t('features.card1_title'),
      desc: t('features.card1_desc'),
      link: '/article/yoybuy-spreadsheet-guide',
    },
    {
      icon: 'ri-scales-3-line',
      image: featureImages[1],
      title: t('features.card2_title'),
      desc: t('features.card2_desc'),
      link: '/article/yoybuy-vs-kakobuy-spreadsheet',
    },
    {
      icon: 'ri-plane-line',
      image: featureImages[2],
      title: t('features.card3_title'),
      desc: t('features.card3_desc'),
      link: '/article/dostavka-iz-kitaya-spreadsheet',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-light text-foreground-500 uppercase tracking-wider">
            {t('features.title_small')}
          </p>
          <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-[1.2]">
            {t('features.title')}
            <br />
            {t('features.title_line2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl overflow-hidden flex flex-col group"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 md:p-8 flex flex-col flex-1">
                <span className="w-10 h-10 flex items-center justify-center text-xl text-foreground-800">
                  <i className={feature.icon}></i>
                </span>
                <h3 className="mt-4 text-lg md:text-xl font-semibold text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
                {feature.link && (
                  <div className="mt-auto pt-6">
                    <Link
                      to={feature.link}
                      className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                    >
                      {t('features.read_article')}
                    </Link>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}